// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack, Text } from '@mantine/core';

import { CreateEditPartFields } from 'modules/Shop/CatalogSetup/CreateEditPartFields';

export const EditItemPane = () => (
  <Stack style={{ overflowY: 'scroll' }} pr="xs">
    <Text fw="bold">Assembly Properties</Text>
    <CreateEditPartFields />
  </Stack>
);
